import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { playSound } from '@/utils/sound';
import { AddParticipantInfo, IRoomState, ParticipantInfo, ParticipantSid, ToggleParticipantMedia } from './types';

const initialState: IRoomState = {
  pinned: null,
  participants: [],
  participantsById: {},
};

const roomSlice = createSlice({
  name: 'room',
  initialState,
  reducers: {
    addParticipant(state, action: PayloadAction<Omit<ParticipantInfo, 'user'>>) {
      const exists = state.participants.includes(action.payload.sid);
      if (!exists) {
        playSound('/media/call-join.mp3');
        state.participants.push(action.payload.sid);
      }

      state.participantsById[action.payload.sid] = {
        ...action.payload,
        user: null,
      };
    },
    addParticipantInfo(state, action: PayloadAction<AddParticipantInfo>) {
      state.participantsById[action.payload.sid].user = action.payload.user;
    },
    toggleParticipantMedia(state, action: PayloadAction<ToggleParticipantMedia>) {
      switch (action.payload.kind) {
        case 'audio':
          state.participantsById[action.payload.sid].isAudioEnabled = action.payload.enabled;
          break;
        case 'video':
          state.participantsById[action.payload.sid].isVideoEnabled = action.payload.enabled;
          break;
        default:
          break;
      }
    },
    removeParticipant(state, action: PayloadAction<ParticipantSid>) {
      if (action.payload === state.pinned) {
        state.pinned = null;
      }

      state.participants = state.participants.filter(p => p !== action.payload);
      delete state.participantsById[action.payload];

      if (state.participants.length === 1 && state.pinned) {
        state.pinned = null;
      }
    },
    toggleRoomPinned(state, action: PayloadAction<ParticipantSid>) {
      if (action.payload === state.pinned) {
        state.pinned = null;
      } else {
        state.pinned = action.payload;
      }
    },
    resetRoom() {
      return initialState;
    },
  },
});

export const {
  resetRoom,
  addParticipant,
  toggleRoomPinned,
  removeParticipant,
  addParticipantInfo,
  toggleParticipantMedia,
} = roomSlice.actions;
export default roomSlice.reducer;